/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import { createIconComponent } from 'uikit/icons';

import MoreHoriz from '@mui/icons-material/MoreHoriz';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';
import { Menu, MenuItem } from 'uikit/menus';

import styles from '../styles/uikitCardsCardMenu.module.scss';

const VARIANT_CLASSES = {
  embed: styles.isContainerEmbed,
  grid: styles.isContainerGrid,
  list: styles.isContainerList,
};

const CardMenu = ({ children, menuItems, variant, className = '', testId = '' }) => {
  const [isMenuOpen, setisMenuOpen] = useState(false);
  const onMenuIsOpenChange = ({ isOpen }) => setisMenuOpen(isOpen);

  return (
    <div
      className={classnames(
        styles.element,
        VARIANT_CLASSES[variant],
        className,
        'cardMenuContainer',
      )}
      data-testid={testId}
    >
      {children}
      {menuItems.length && variant !== 'embed' && (
        <div className={styles.menuContainer}>
          <Menu
            component={
              <Button
                icon={<MoreHoriz />}
                variant="ghost"
                size="xsmall"
                aria-label={i18n.t('options', 'Options')}
              />
            }
            onIsOpenChange={onMenuIsOpenChange}
            variant="unbounded"
          >
            {menuItems.map((item) => item)}
          </Menu>
        </div>
      )}
    </div>
  );
};

const Item = ({
  icon,
  text,
  isDisabled = false,
  isLink = false,
  route = '',
  onClick = null,
  ...props
}) => {
  const Element = isLink ? Link : Fragment;

  return (
    <MenuItem {...props} isDisabled={isDisabled} onClick={!isDisabled ? onClick : null}>
      <Element {...(isLink && !isDisabled && route && { to: route })}>
        {icon && createIconComponent({ icon })}
        <Typo variant="s02" element="div">
          {text}
        </Typo>
      </Element>
      {isDisabled && (
        <div className={styles.isDisabledAccessibilityText}>
          {i18n.t('option-not-available', 'Option not available')}
        </div>
      )}
    </MenuItem>
  );
};

CardMenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.element).isRequired,
  variant: PropTypes.oneOf(['embed', 'grid', 'list']),
  className: PropTypes.string,
  testId: PropTypes.string,
  children: PropTypes.element.isRequired,
};

Item.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  text: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

CardMenu.Item = Item;

export { CardMenu as CardMenuStorybook };
export default CardMenu;
